/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CountriesFormComponent } from '@app/settings/countries/countries-form/countries-form.component';
import { Country } from '@app/settings/countries/countries.model';

@Injectable({
  providedIn: 'root',
})
export class CountriesFormService {
  constructor(private modalService: NgbModal) {}

  /**
   * Open country form
   * @param country Dialog data
   */
  public open(country: null | Country = null): Promise<any> {
    const modal = this.modalService.open(CountriesFormComponent);
    modal.componentInstance.country = country;
    return modal.result;
  }
}
